const darkBlue1 = "#002566" //primary
const darkBlue2 = "#122F53" 
const blue1 = "#0082E3"
const blue2 = "#316BDE"
const lightBlue1 = "#38C2F1"
const lightBlue2 = "#ECFAFF"
const blackFull = "#000000"
const darkGrey1 = "#9A9A9A"
const darkGrey2 = "#696969"
const lightGrey1 = "#F1F1F1" //secondary

const btnStyle = {
    py: 2,
    px: [3, 4],
    transition: "all 0.3s ease-in",
}
// example theme file
const theme = {
    breakpoints: [
        "0px", // 0
        "380px", // 1
        "576px", // 2
        "768px", // 3
        "992px", // 4
        "1100px", // 5
        "1200px", // 6
        "1293px", // 7
        "1400px", // 8
    ],
    // breakpoints: ['0px', '576px', '768px', '992px', '1200px', '1400px'],
    sizes: {
        container: [
            "100%",
            "100%",
            "100%",
            "100%",
            "100%",
            "960px",
            "960px",
            "1140px",
            "1320px",
        ],
    },
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fonts: {
        body: "Gilroy, sans-serif",
        heading: "Gilroy",
        monospace: "monospace",
    },
    fontSizes: [11, 12, 14, 16, 22, 30, 40, 60, 70, 80, 90, 135],
    fontWeights: {
        body: 400,
        heading: 700,
        bold: "800",
    },
    lineHeights: {
        body: 1.5,
        heading: 1.25,
        normal: 1,
    },
    colors: {
        text1: blackFull,
        text2: darkGrey2,
        background: "#fff",
        primary: darkBlue1,
        secondary: lightGrey1,
        blue1: blue1,
        blue2: blue2,
        light_blue_1: lightBlue1,
        light_blue_2: lightBlue2,
        dark_grey_1: darkGrey1,
        dark_grey_2: darkGrey2,
        light_grey_1: lightGrey1,
    },
    styles: {
        root: {
            fontFamily: "body",
            lineHeight: "body",
            fontWeight: "body",
        },
        h1: {
            fontFamily: "heading",
            lineHeight: "heading",
            fontWeight: "heading",
        },
        h2: {
            fontFamily: "heading",
            lineHeight: "heading",
            fontWeight: "heading",
            color: "primary",
        },
        h3: {
            fontFamily: "body",
            lineHeight: "heading",
            fontWeight: "heading",
        },
        h4: {
            fontFamily: "body",
            lineHeight: "heading",
            fontWeight: "heading",
            fontSize: 4,
        },
        h5: {
            fontFamily: "body",
            lineHeight: "heading",
            fontWeight: "heading",
            fontSize: 4,
            color: "primary",
            textTransform: "capitalize",
        },
        h6: {
            color: "primary",
            fontFamily: "heading",
            lineHeight: "heading",
            fontWeight: "heading",
            fontSize: 0,
        },
        p: {
            color: "primary",
            fontFamily: "body",
            fontWeight: "body",
            lineHeight: "body",
        },
        a: {
            color: "primary",
            textDecoration: "none",
            "&:hover": {
                textDecoration: "underline",
            },
        },
        pre: {
            fontFamily: "monospace",
            overflowX: "auto",
            code: {
                color: "inherit",
            },
        },
        code: {
            fontFamily: "monospace",
            fontSize: "inherit",
        },
        table: {
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
        },
        th: {
            textAlign: "left",
            borderBottomStyle: "solid",
        },
        td: {
            textAlign: "left",
            borderBottomStyle: "solid",
        },
        img: {
            maxWidth: "100%",
        },
    },
    text: {
        pageHeading: {
            fontFamily: "heading",
            fontWeight: "normal",
            lineHeight: "normal",
            color: "primary",
            fontSize: [5, 6, 7, 8],
            textTransform: "uppercase",
        },
        heading: {
            fontFamily: "heading",
            fontWeight: "body",
            lineHeight: "normal",
            color: "primary",
            fontSize: [4, 5],
            textTransform: "uppercase",
        },
        headerText: {
            fontFamily: "body",
            fontWeight: "heading",
            lineHeight: "heading",
            fontSize: [3, 4, 5],
            color: "primary",
        },

        breadcrumb: {
            fontSize: [1, 2, 3],
        },
        footerText: {
            fontSize: [1, 2],
        },
        tag: {
            px: 3,
            py: 1,
            fontSize: 0,
            textTransform: "uppercase",
            color: "#FFF",
            marginRight: 2,
            "&.promo": {
                bg: "#F00000",
            },
            "&.workshop": {
                bg: "#EC247C",
            },
            "&.event": {
                bg: "#EC247C",
            },
            "&.program": {
                bg: "#FFCF17",
            },
            "&.newsletter": {
                bg: "#0AA8E9",
            },
        },
    },
    buttons: {
        primary: {
            backgroundColor: "main",
            color: "secondary",
            fontWeight: "bold",
            ...btnStyle,
        },
        form: {
            backgroundColor: "transparent",
            color: "#000",
        },
        mobile: {
            ...btnStyle,
            px: 0,
        },
        small: {
            py: 1,
            px: 2,
            fontSize: 0,
            backgroundColor: "#FFF",
            color: "primary",
            borderWidth: 1,
            borderColor: "primary",
            borderStyle: "solid",
            borderRadius: "20px",
            transition: "all 0.3s ease-in-out",
            "&:hover": {
                backgroundColor: "primary",
                color: "#FFF",
                cursor: "pointer",
            },
        },
    },
    links: {
        nav: {
            px: 2,
            py: 1,
            mx: "auto",
            fontSize: 0,
            textDecoration: "none",
        },
        buttonSquare: {
            bg: "transparent",
            color: "primary",
            borderWidth: "2px",
            borderColor: "primary",
            borderStyle: "solid",
            fontWeight: "heading",
            ...btnStyle,
            "&:hover, &:active": {
                bg: "primary",
                color: "#FFF",
            },
            "&.reverse": {
                bg: "primary",
                color: "#FFF",
                "&:hover, &:active": {
                    bg: "#FFF",
                    color: "primary",
                },
            },
        },
    },
    forms: {
        checkbox: {
            color: "muted",
        },
        label: {
            color: "secondary_purple",
            textTransform: "capitalize",
        },
        searchInput: {
            border: "none",
            padding: 1,
            "&:focus": {
                outline: "none",
            },
        },
    },
}
export default theme
